import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { DbMarkerCategory } from "./db-marker-category";
import { DbMarkerSeverity } from "./db-marker-severity";
import { DbMarkerLevel } from "./db-marker-level";
import { DbMarkerStatus } from "./db-marker-status";
import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";
import { DbAssetMarkerFamilyInfos } from "./db-asset-marker-family-infos";
import { DbAssetMarkerTypeInfos } from "./db-asset-marker-type-infos";

export class DbAssetMarkerInfos extends DbMongoSerializationBaseInfos {
  objectId: number | null = 0;
  familyId: number | null = 0;
  typeId: number | null = 0;
  frameIn: number | null = 0;
  frameRate: number | null = 0;
  category: DbMarkerCategory | null = null;
  severity: DbMarkerSeverity | null = null;
  level: DbMarkerLevel | null = DbMarkerLevel.Normal;
  comment: string | null = null;
  commentReviewer: string | null = null;
  frameOut: number | null = 0;
  platformId: number | null = 0;
  status: DbMarkerStatus | null = null;
  creationInfos: DbObjectCreateOrUpdateInfos | null = null;
  thumbnailIn: { $type: string; $value: string } | null = null;
  thumbnailOut: { $type: string; $value: string } | null = null;
  updateInfos: DbObjectCreateOrUpdateInfos[] | null = null;
  familyInfos: DbAssetMarkerFamilyInfos | null = null;
  typeInfos: DbAssetMarkerTypeInfos | null = null;
  timecodeIn: string | null = null;
  timecodeOut: string | null = null;
  timecodeInFile: string | null = null;
  timecodeOutFile: string | null = null;

  constructor(init?: Partial<DbAssetMarkerInfos>) {
    super();
    Object.assign(this, init);
  }
}
